(() => {
  const mount = () => document.querySelectorAll('.lp-student-show').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const img = root.querySelector('img'), credit = root.querySelector('[data-credit]');
    const slides = [{src: img.currentSrc || img.src, credit: credit.textContent, alt: img.alt}, ...Array.from(root.querySelectorAll('[data-slide]'), item => ({src:item.dataset.src,credit:item.dataset.credit,alt:`Student photograph by ${item.dataset.credit}`}))];
    if (slides.length < 2) return;
    const controls = root.querySelector('.lp-show-controls'), pause = root.querySelector('[data-pause]'), count = root.querySelector('[data-count]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches, visible = false, busy = false, index = 0;
    const sync = () => { pause.textContent = paused ? 'Play slideshow' : 'Pause slideshow'; pause.setAttribute('aria-pressed', String(paused)); count.textContent = `${index + 1} / ${slides.length}`; };
    const advance = async direction => {
      if (busy) return;
      busy = true;
      const next = (index + direction + slides.length) % slides.length, slide = slides[next], preload = new Image();
      try {
        preload.src = slide.src; await preload.decode();
        if (!root.isConnected) return;
        if (!reduced.matches) await img.animate([{opacity:1},{opacity:.15}],{duration:180,fill:'forwards'}).finished;
        img.removeAttribute('srcset'); img.src = slide.src; img.alt = slide.alt; credit.textContent = slide.credit; index = next;
        img.getAnimations().forEach(animation => animation.cancel());
        if (!reduced.matches) img.animate([{opacity:.15},{opacity:1}],{duration:300});
        sync();
      } catch (_) { img.getAnimations().forEach(animation => animation.cancel()); }
      finally { busy = false; }
    };
    controls.hidden = false; sync();
    pause.addEventListener('click', () => { paused = !paused; sync(); });
    for (const [selector,direction] of [['[data-next]',1],['[data-prev]',-1]]) root.querySelector(selector).addEventListener('click', () => {paused = true; sync(); advance(direction);});
    reduced.addEventListener('change', () => {paused = reduced.matches;sync();});
    const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;},{threshold:.2}); observer.observe(root);
    const timer = setInterval(() => {if (!root.isConnected) {clearInterval(timer);observer.disconnect();return;} if (visible && !paused && !document.hidden && !root.matches(':hover') && !root.contains(document.activeElement)) advance(1);},6500);
  });
  mount(); document.addEventListener('shopify:section:load', mount);
})();
